import React from 'react'
import { Icon } from './'

const IconText = (props) => (
  <span
    {...props.events}
    className={`ui gp-icon-text icon-text-${props.group} ${props.className} ${
      props.reversed ? 'reversed' : ''
    }`}
    style={props.style}
  >
    {props.iconSpan ? (
      <span>
        <Icon name={props.icon} {...props.iconProps} />
      </span>
    ) : (
      <Icon name={props.icon} {...props.iconProps} />
    )}

    <span className='value'>{props.value}</span>
    <span className='children'>{props.children}</span>
  </span>
)

IconText.defaultProps = {
  events: {},
  group: 'a',
  className: '',
  style: {},
  iconProps: {},
  iconSpan: false
}

export default IconText
